import { InfoHubLayout } from 'views/InfoHub/Layout'
import TokenDetailView from 'views/InfoHub/TokenDetailView'
import { InfoDexGuard } from 'views/InfoHub/guard'

const Page = () => (
  <InfoDexGuard>
    <TokenDetailView />
  </InfoDexGuard>
)
Page.Layout = InfoHubLayout
Page.chains = [] // set all
export default Page
